export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10030.4dfaa3b5.jpg";